// src/components/SidebarContentWrapper.jsx
import React from "react";
import {
  SidebarContent,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
} from "./sidebar";
import {
  LayoutDashboard,
  Video,
  PlayCircle,
  Calendar,
  Users,
  Settings,
} from "lucide-react";
import { useNavigate, useLocation, Link } from "react-router-dom";

export default function SidebarContentWrapper() {
  const navigate = useNavigate();
  const location = useLocation();

  const user = JSON.parse(localStorage.getItem("user")) || {};
  const roleId = Number(user.role_id);
  const orgId = Number(user.organization_id);

  const isActive = (path) => location.pathname === path;

  const menuClass = (path) =>
    `p-4 mx-2 my-1 rounded-lg transition-all duration-200 font-medium flex items-center gap-3
     ${isActive(path)
      ? "bg-primary text-primary-foreground shadow-md"
      : "hover:bg-muted hover:text-foreground"
    }`;

  return (
    <SidebarContent className="bg-gradient-to-b from-white via-white to-green-100 pr-5">
      <SidebarMenu className="gap-1">

        {/* Logo */}
        <SidebarMenuItem className="p-6 text-center border-b">
          <Link to="/landing" className="flex flex-col items-center gap-2">
            <img
              src="/favicon.ico"
              alt="Court Replay Logo"
              className="w-10 h-10 object-contain"
            />
            <span className="text-2xl font-bold tracking-tight">
              Court Replay
            </span>
          </Link>
        </SidebarMenuItem>

        {/* Profile */}
        <SidebarMenuItem>
          <SidebarMenuButton
            className={menuClass("/profile")}
            onClick={() => navigate("/profile")}
          >
            <Users className="w-5 h-5" />
            <span>Profile</span>
          </SidebarMenuButton>
        </SidebarMenuItem>

        {/* Brands */}
        <SidebarMenuItem>
          <SidebarMenuButton
            className={menuClass("/brands")}
            onClick={() => navigate("/brands")}
          >
            <LayoutDashboard className="w-5 h-5" />
            <span>Brands</span>
          </SidebarMenuButton>
        </SidebarMenuItem>

        {/* Library */}
        <SidebarMenuItem>
          <SidebarMenuButton
            className={menuClass("/library")}
            onClick={() => navigate("/library")}
          >
            <Video className="w-5 h-5" />
            <span>My Library</span>
          </SidebarMenuButton>
        </SidebarMenuItem>

        {/* Transaction History */}
        <SidebarMenuItem>
          <SidebarMenuButton
            className={menuClass("/transaction-history")}
            onClick={() => navigate("/transaction-history")}
          >
            <Calendar className="w-5 h-5" />
            <span>Transaction History</span>
          </SidebarMenuButton>
        </SidebarMenuItem>

        {/* Cart */}
        <SidebarMenuItem>
          <SidebarMenuButton
            className={menuClass("/cart")}
            onClick={() => navigate("/cart")}
          >
            <PlayCircle className="w-5 h-5" />
            <span>Cart</span>
          </SidebarMenuButton>
        </SidebarMenuItem>

        {/* Admin */}
        {roleId === 1 && (
          <SidebarMenuItem>
            <SidebarMenuButton
              className={menuClass("/admin-dashboard")}
              onClick={() => navigate("/admin-dashboard")}
            >
              <Settings className="w-5 h-5" />
              <span>Admin Dashboard</span>
            </SidebarMenuButton>
          </SidebarMenuItem>
        )}

        {/* Manager */}
        {orgId !== 0 && Object.keys(user).length !== 0 && (
          <SidebarMenuItem>
            <SidebarMenuButton
              className={menuClass("/manager-tools")}
              onClick={() => navigate("/manager-tools")}
            >
              <Settings className="w-5 h-5" />
              <span>Manager Tools</span>
            </SidebarMenuButton>

            {roleId === 0 && (
              <div className="mx-4 mt-1 mb-2 text-xs text-muted-foreground">
                Organization ID: {orgId}
              </div>
            )}
          </SidebarMenuItem>
        )}
      </SidebarMenu>
    </SidebarContent>
  );
}